var Application;

Application = {
    ready: function () {

        this.Forms.ready();
        this.Postcard.ready();
        this.Wordmark.ready();
        this.Branding.ready();
        this.QrCode.ready();
        this.Signature.ready();
        this.SvgIcons.ready();
        this.Tooltips.ready();
        this.Popups.ready();
        this.Floaters.ready();
        this.Upload.ready();
        this.CustomRadio.ready();
        this.CategoryList.ready();

    }
};

// Initiate the application
jQuery(function () {
    Application.ready();
});